import { render, staticRenderFns } from "./dateSelect.vue?vue&type=template&id=1224a5a4&scoped=true&"
import script from "./dateSelect.vue?vue&type=script&lang=js&"
export * from "./dateSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1224a5a4",
  null
  
)

export default component.exports